module.exports = __webpack_public_path__ + "assets/img/12_138_big.32c2d445.jpg";